import { render, staticRenderFns } from "./DialogSalesInvoice.vue?vue&type=template&id=580e2fa7"
import script from "./DialogSalesInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSalesInvoice.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports